import React from 'react';
import './textarea.style.scss';

const TextArea = ({ ...props }) => {
  return <textarea {...props} />;
};

export default TextArea;
